var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipHalal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM9.34 8.66C9.54 8.46 9.85 8.46 10.05 8.66C10.99 9.6 11.58 11 11.58 12.3C11.58 12.58 11.36 12.8 11.08 12.8C10.8 12.8 10.58 12.58 10.58 12.3C10.58 11.05 9.94 9.96 9.35 9.37C9.15 9.17 9.15 8.86 9.35 8.66H9.34ZM8.26 13.24C8.26 14.05 7.6 14.71 6.79 14.71H5.94C5.13 14.71 4.47 14.05 4.47 13.24V12.71C4.47 12.43 4.69 12.21 4.97 12.21C5.25 12.21 5.47 12.43 5.47 12.71V13.24C5.47 13.5 5.68 13.71 5.94 13.71H6.79C7.05 13.71 7.26 13.5 7.26 13.24V8.06C7.26 7.78 7.48 7.56 7.76 7.56C8.04 7.56 8.26 7.78 8.26 8.06V13.24ZM13.73 14.61C13.27 14.61 12.89 14.36 12.66 14C12.24 14.38 11.7 14.61 11.09 14.61H9.23C8.95 14.61 8.73 14.39 8.73 14.11C8.73 13.83 8.95 13.61 9.23 13.61H11.09C11.83 13.61 12.44 13.01 12.44 12.26V8C12.44 7.72 12.66 7.5 12.94 7.5C13.22 7.5 13.44 7.72 13.44 8V13.31C13.44 13.47 13.57 13.61 13.74 13.61H17.1C17.05 12.9 16.46 12.33 15.74 12.33H14.71C14.43 12.33 14.21 12.11 14.21 11.83C14.21 11.55 14.43 11.33 14.71 11.33H15.74C17.02 11.33 18.05 12.34 18.1 13.61H18.96C19.24 13.61 19.46 13.83 19.46 14.11C19.46 14.39 19.24 14.61 18.96 14.61H13.73Z",
    fill: "#004F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipHalal);
export default __webpack_public_path__ + "static/media/ic-chip-halal.a15a2184ae4342f59428be6a1e2aaea8.svg";
export { ForwardRef as ReactComponent };